import { BaseUnit } from './BaseUnit';
import { Enemy } from '../Enemy';
import { Projectile } from '../Projectile';
import { BOOMERANG_THROWER } from '../../config';
import { StickFigureGraphics } from '../../rendering/StickFigureGraphics';

export class BoomerangThrower extends BaseUnit {
  private attackTimer: number = 0;
  private throwPhase: number = 0;
  private projectiles: Projectile[];

  constructor(scene: Phaser.Scene, x: number, y: number, slotIndex: number, projectiles: Projectile[]) {
    super(scene, x, y, slotIndex);
    this.projectiles = projectiles;
    this.targetPriority = 'nearest';
    this.draw();
  }

  getDamage(): number {
    return Math.round(BOOMERANG_THROWER.baseDamage * this.bonusDamageMult * this.globalDamageMult) * this.stackCount;
  }

  getPierceCount(): number {
    return BOOMERANG_THROWER.basePierceCount + this.bonusPierceCount;
  }

  update(_time: number, delta: number, enemies: Enemy[]): void {
    if (this.throwPhase > 0) {
      this.throwPhase -= delta * 0.003;
      if (this.throwPhase < 0) this.throwPhase = 0;
    }

    this.attackTimer -= delta;
    if (this.attackTimer <= 0) {
      const target = this.findTarget(enemies, BOOMERANG_THROWER.range);
      if (target) {
        this.attackTimer = this.getEffectiveAttackInterval(BOOMERANG_THROWER.attackInterval);
        this.throwPhase = 1;
        this.fire(target);
      } else {
        this.attackTimer = 0;
      }
    }

    this.draw();
  }

  private fire(target: Enemy): void {
    const numProjectiles = 1 + this.bonusProjectiles;
    const spreadStep = 20; // vertical spread between multiple boomerangs

    for (let i = 0; i < numProjectiles; i++) {
      const offsetY = (i - (numProjectiles - 1) / 2) * spreadStep;
      const startX = this.x + 10;
      const startY = this.y - 15 + offsetY;

      // Target X is the wall edge + range (how far the boomerang travels out)
      const targetX = startX + BOOMERANG_THROWER.range;

      const proj = new Projectile(this.scene, startX, startY, {
        damage: this.getDamage(),
        speed: BOOMERANG_THROWER.projectileSpeed,
        piercing: true,
        projectileType: 'boomerang',
        targetX,
        targetY: target.y + offsetY,
        maxPierceCount: this.getPierceCount(),
      });

      // Boomerangs always travel horizontally to the right
      proj.velocityX = BOOMERANG_THROWER.projectileSpeed;
      proj.velocityY = 0;

      this.projectiles.push(proj);
    }
  }

  draw(): void {
    if (this.throwPhase <= 0) {
      this.sprite.setTexture('friendly_boomerang_idle');
    } else {
      let frame = Math.floor((1 - this.throwPhase) * 8);
      if (frame < 0) frame = 0;
      if (frame > 7) frame = 7;
      this.sprite.setTexture(`friendly_boomerang_${frame}`);
    }

    this.graphics.clear();
    if (this.level > 1) {
      this.graphics.fillStyle(0xffd700, 1);
      for (let i = 0; i < Math.min(this.level - 1, 5); i++) {
        this.graphics.fillCircle(this.x - 8 + i * 4, this.y + 16, 1.5);
      }
    }
  }
}
